 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import BACKEDEBADFRONT from '@/components/Backed/ebadfront'
 import BACKEDPORTALISTAD from '@/components/Backed/portalistad'
 import ADVERTFRONTADD from '@/components/Advert/Front-add'
 import TITLE from '@/components/Title'
 import SECTION1 from '@/components/section1'
 import SECTION2 from '@/components/section2'
 import SECTION3 from '@/components/section3'
 import SECTION4 from '@/components/section4'
 import LOVE_1 from '@/components/love_1'
 import PREVIEW from '@/components/Preview'
 import PREVIEW_COVER from '@/components/Preview_cover'
 import PREVIEW_1 from '@/components/Preview_1'
 import PREVIEW_2 from '@/components/Preview_2'
 import PREVIEW_3 from '@/components/Preview_3'
 import AUTHORBIO from '@/components/AuthorBio'
 import COPYRIGHT from '@/components/copyright'
 import BACKEDAUBA from '@/components/Backed/auba'
 import BACKEDORIMAD from '@/components/Backed/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/Backed/ebadfront",
 			"name" : "Backed/ebadfront",
 			"component" : BACKEDEBADFRONT
 		},
 		{
 			"path" : "/Backed/portalistad",
 			"name" : "Backed/portalistad",
 			"component" : BACKEDPORTALISTAD
 		},
 		{
 			"path" : "/Advert/Front-add",
 			"name" : "Advert/Front-add",
 			"component" : ADVERTFRONTADD
 		},
 		{
 			"path" : "/Title",
 			"name" : "Title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/section1",
 			"name" : "section1",
 			"component" : SECTION1
 		},
 		{
 			"path" : "/section2",
 			"name" : "section2",
 			"component" : SECTION2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js